export const BRAND = process.env.REACT_APP_BRAND || 'supermont';
